module.exports = __webpack_public_path__ + "img/qdzx.36024ca6.png";